import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, Fragment, useState } from "react";
import {
  Button,
  Form, FormControl,
  InputGroup,
  Modal,
  Spinner
} from "react-bootstrap";
import Vehicle, { IVehicleResource } from "../../models/vehicle";
interface Props {
  vehicle: IVehicleResource;
  onDeleted?: (vehicle: IVehicleResource) => void;
}
const DeleteVehicle: React.FC<Props> = ({ vehicle, onDeleted }) => {
  const [loading, setLoading] = useState(false);
  const [shown, setShown] = useState(false);
  const deleteVehicle = async () => {
    try {
      setLoading(true);
      await Vehicle.Delete(vehicle)
      setLoading(false);
      setShown(false);
      if (onDeleted) {
        onDeleted(vehicle);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const formDelete = async (event: FormEvent) => {
    event.preventDefault();
    await deleteVehicle();
  };
  return (
    <Fragment>
      <button
        title="Slet køretøj"
        className="blank-button"
        onClick={() => setShown(true)}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>

      <Modal show={shown} onHide={() => setShown(true)}>
        <form onSubmit={formDelete}>
          <Modal.Title>Slet køretøj</Modal.Title>
          <Modal.Body>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Indregisterings nr.</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl readOnly={true} defaultValue={vehicle.alias} />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Kaldenavn</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  readOnly={true}
                  defaultValue={vehicle.licensePlate}
                />
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="warning" disabled={loading} type="submit">
              Slet {loading && <Spinner animation="border" size="sm" />}
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setShown(false);
              }}
            >
              Luk
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </Fragment>
  );
};

export default DeleteVehicle;
